var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import dayjs from 'dayjs';
export function convertTimelineEventResponse(timelineEventResponse) {
    var timelineEvent = {
        id: timelineEventResponse.id,
        title: timelineEventResponse.title,
        description: timelineEventResponse.description,
        startDate: dayjs.utc(timelineEventResponse.startDate, 'YYYY-MM-DD'),
        endDate: timelineEventResponse.endDate ? dayjs.utc(timelineEventResponse.endDate, 'YYYY-MM-DD') : null,
    };
    return timelineEvent;
}
export function convertTimelineSectionsResponse(timelineSectionResponse) {
    return __assign(__assign({}, timelineSectionResponse), { date: dayjs(timelineSectionResponse.date), events: timelineSectionResponse.events.length > 0 ? timelineSectionResponse.events.map(convertTimelineEventResponse) : [] });
}
//# sourceMappingURL=apiConversions.js.map